import React, { Component } from 'react';
import './collage.css';



import bg        from '../assets/bg.png';
import lady      from '../assets/image 2.png';
import mona      from '../assets/mona.png';
import young     from '../assets/young.png';
import adoration from '../assets/image 4.png';
import self_     from '../assets/image 5.png';
import torn      from '../assets/papper.png';
import bf1       from '../assets/bf1.png';
import bf2       from '../assets/bf2.png';
import bf3       from '../assets/bf3.png';

function Collage() {
    return (
        <section className="collage-section">
      <div className="cl-wrap">

        <img src={bg} alt="background" className="cl-bg-img" />
        <div className="cl-bg-overlay" />


        <div className="cl-img2">
          <img src={lady} alt="Lady with an Ermine" />
        </div>

        <div className="cl-img3">
          <img src={mona} alt="Mona Lisa" />
        </div>

        <div className="cl-img4">
          <img src={young} alt="Portrait of a Young Woman" />
        </div>

        <img src={bf1} alt="butterfly" className="butterfly bf-img4" />

        <div className="cl-img5">
          <img src={adoration} alt="Adoration of the Magi" />
        </div>


        <div className="cl-img7">
          <img src={self_} alt="Leonardo young portrait" className="cl-img7-photo" />
        </div>

        <img src={bf2} alt="butterfly" className="butterfly bf-img7" />

        <div className="cl-torn">
          <img src={torn} alt="torn paper" className="cl-torn-img" />
        </div>

        <img src={bf3} alt="butterfly" className="butterfly bf-torn" />

       
      </div>
    </section>
      );
    }
    

export default Collage;